import {BLANK_FAMILY} from 'src/modules/user-settings/constants';
import {createTreeItemId} from 'src/modules/user-settings/utils/createTreeItemId';
import {getAllSources} from 'src/modules/user-settings/utils/getAllSources';
import {EventUpdateSubscription} from 'src/openapi/models/EventUpdateSubscription';

const ALL_SOURCES = 'ALL_SOURCES';
const ALL_FAMILIES = 'ALL_FAMILIES';

const createCheckedIdsFromFamilies = (
    source: string,
    families: string[],
    allAvailableFamilies: string[],
): string[] => {
    if (families.includes(ALL_FAMILIES)) {
        return allAvailableFamilies.map(item => createTreeItemId(source, item));
    }

    return families.map(family => createTreeItemId(source, family));
};

export const createCheckedIdsFromEventSubscriptions = (
    subscriptions: EventUpdateSubscription[],
    availableFamilies: string[],
): string[] => {
    const allSources = getAllSources();
    const allFamilies = [BLANK_FAMILY, ...availableFamilies];

    const isAllSourcesSelected = subscriptions.some(subscription => subscription.source === ALL_SOURCES);

    if (isAllSourcesSelected) {
        const checkedIds = allSources.flatMap(source =>
            allFamilies.map(family => createTreeItemId(source, family)));

        return [ALL_SOURCES, ...checkedIds];
    }

    return subscriptions.flatMap(({source, families}) =>
        createCheckedIdsFromFamilies(source, families, allFamilies));
};
